import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { PostponePopupComponent } from "../postpone-popup/postpone-popup.component";
import { SucessPopupComponent } from "../sucess-popup/sucess-popup.component";
import { ReconnectinPopupComponent } from "../reconnectin-popup/reconnectin-popup.component";
import { ValueAppointmentType } from "../consults-page/consults-page.component";

@Component({
  selector: "app-callfeeback",
  templateUrl: "./callfeeback.component.html",
  styleUrls: ["./callfeeback.component.scss"],
})
export class CallfeebackComponent implements OnInit {
  dialogRef: any = null;
  
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {}

  get isNotScheduled() {
    return this.data !== ValueAppointmentType.SCHEDULED;
  }

  postponePopup() {
    if ( this.dialogRef ) {
      this.dialogRef.close();
    }
    this.dialogRef = this.dialog.open(PostponePopupComponent, {
      width: "330px",
      disableClose: true,
      autoFocus: false,
    });

    this.dialogRef.afterClosed().subscribe((_: any) => {
      this.dialogRef = null;
    });
  }

  sucessPopup() {
    this.dialogRef = this.dialog.open(SucessPopupComponent, {
      width: "330px",
      disableClose: true,
      autoFocus: false,
      // height:'165px'
    });

    this.dialogRef.afterClosed().subscribe((_) => {
      this.dialogRef = null;
    });
  }
  reconnectingPopup() {
    this.dialogRef = this.dialog.open(ReconnectinPopupComponent, {
      width: "550px",
      disableClose: true,
      autoFocus: false,
      // height:'165px'
    });

    this.dialogRef.afterClosed().subscribe((_: any) => {
      this.dialogRef = null;
    });
  }
}
